import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { ApplicationService } from 'app/services/application.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';

@Component({
    selector: 'app-calendar-events',
    standalone: true,
    imports: [
        CommonModule,
        MatIconModule,
        HeaderComponent,
        TranslateModule,
        MatSnackBarModule
    ],
    templateUrl: './calendar-events.component.html',
})
export class CalendarEventsComponent {
    @Input() events;
    @Output() pickedLanguage: EventEmitter<any> = new EventEmitter();
    selectedLanguage: any;
    isAuthenticated = false;
    isExpandDescription = false;
    calendarEventIdClick;
    receiveCalendarEventId: Subscription;
    successMsg: string = '';

    eventURL = 'cgc-developmental-programme/registration?calendarEventId=';
    languageURL = '&lang=';

    constructor(
        private router: Router,
        private _snackBar: MatSnackBar,
        public translate: TranslateService,
        private activatedRoute: ActivatedRoute,
        private applicationService: ApplicationService
    ) {
        this.selectedLanguage = localStorage.getItem('language');
        this.isAuthenticated =
            localStorage.getItem('isAuthenticated') == 'true' ? true : false;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes?.events && this.events?.length) {
            this.events.map((ele) => {
                ele.descriptionExpand = false;
            });
            /* GET Event ID from click*/
            this.receiveCalendarEventId =
                this.applicationService.sendCalendarEventId.subscribe(
                    (calendarEventId) => {
                        if (calendarEventId)
                            this.scrollToCalendarEvent(calendarEventId);
                    }
                );
            /* GET Event ID from form*/
            let calendarEventId;
            this.activatedRoute.queryParams.subscribe((params) => {
                calendarEventId = params.calendarEventId;
            });
            if (calendarEventId) {
                this.scrollToCalendarEvent(calendarEventId);
            }
        }
    }

    scrollToCalendarEvent(element) {
        if (element)
            document.getElementById(element).scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center',
            });
    }

    switchedLanguage(data: any) {
        this.selectedLanguage = data;
        this.pickedLanguage.emit(data);
    }

    checkOverflow(element) {
        return (
            element.offsetHeight < element.scrollHeight ||
            element.offsetWidth < element.scrollWidth
        );
    }

    toggleDescription(id) {
        this.events.map((ele) => {
            if (ele.id == id) ele.descriptionExpand = !ele.descriptionExpand;
        });
    }

    onRegisterEvent(isRegistered, id, title) {
        let userRegistered = isRegistered;
        let calendarEventId = id;
        localStorage.setItem('event_title', title);

        if (
            userRegistered == 'Not Registered to Event' &&
            this.isAuthenticated
        ) {
            this.router.navigate(['/cgc-developmental-programme/registration'], {
                queryParams: {
                    calendarEventId: calendarEventId,
                },
            });
        } else if (userRegistered == 'Not Logged In') {
            this.router.navigate(['/login'], {
                queryParams: {
                    calendarEventURL: `/cgc-developmental-programme/registration?calendarEventId=${calendarEventId}`,
                    lang: this.selectedLanguage
                },
            });
        }
    }

    ngOnDestroy() {
        if (this.receiveCalendarEventId) {
            this.receiveCalendarEventId.unsubscribe();
        }
    }

    copyLink(id: any) {
        const origin = window.location.origin;
        const eventLink = this.eventURL + id;
        const langLink = this.languageURL + this.selectedLanguage;
        const completeLink = origin +'/' + eventLink + langLink;
        navigator.clipboard.writeText(completeLink);
        this._snackBar.open(this.translateSuccessMessage(), 'X',
            {
                duration: 3000,
                panelClass: ['link-copied-snackbar', 'link-copied-snackbar-successfully'],
                horizontalPosition: 'center',
                verticalPosition: 'bottom',
            }
        )
    }

    translateSuccessMessage() {
        this.translate.get('LINK_COPIED_SUCCESSFULLY').subscribe((data: any) => {
            this.successMsg = data;
        });

        return this.successMsg;
    }
}
